import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import { GLOBAL_STATE } from '../constants/actionTypes'
import * as actionTypes from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const USER_SESSIONS_STATE = GLOBAL_STATE

export const { reducer: userSessionsReducer } = createSlice({
  name: USER_SESSIONS_STATE,
  initialState: initialState(),
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.getUserSessions.pending, state => {
        state[actionTypes.USER_SESSIONS].loading = true
      })
      .addCase(actionCreators.getUserSessions.rejected, (state, action) => {
        state[actionTypes.USER_SESSIONS].loading = false
        state[actionTypes.USER_SESSIONS].error = action.payload as AxiosError
      })
      .addCase(actionCreators.getUserSessions.fulfilled, (state, action) => {
        state[actionTypes.USER_SESSIONS].loading = false
        state[actionTypes.USER_SESSIONS].error = null
        state[actionTypes.USER_SESSIONS].data = action.payload
      })

    builder
      .addCase(actionCreators.logoutUserSession.pending, state => {
        state[actionTypes.USER_SESSION_LOGOUT].loading = true
      })
      .addCase(actionCreators.logoutUserSession.rejected, (state, action) => {
        state[actionTypes.USER_SESSION_LOGOUT].loading = false
        state[actionTypes.USER_SESSION_LOGOUT].error = action.payload as AxiosError
      })
      .addCase(actionCreators.logoutUserSession.fulfilled, (state, action) => {
        state[actionTypes.USER_SESSION_LOGOUT].loading = false
        state[actionTypes.USER_SESSION_LOGOUT].error = null
        state[actionTypes.USER_SESSION_LOGOUT].data = action.payload
      })

    builder
      .addCase(actionCreators.logoutAllUserSessions.pending, state => {
        state[actionTypes.USER_SESSIONS_LOGOUT_ALL].loading = true
      })
      .addCase(actionCreators.logoutAllUserSessions.rejected, (state, action) => {
        state[actionTypes.USER_SESSIONS_LOGOUT_ALL].loading = false
        state[actionTypes.USER_SESSIONS_LOGOUT_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.logoutAllUserSessions.fulfilled, (state, action) => {
        state[actionTypes.USER_SESSIONS_LOGOUT_ALL].loading = false
        state[actionTypes.USER_SESSIONS_LOGOUT_ALL].error = null
        state[actionTypes.USER_SESSIONS_LOGOUT_ALL].data = action.payload
      })

    builder.addCase(actionCreators.getUserSessionsClear, state => {
      state[actionTypes.USER_SESSIONS] = defaultState()
    })
  },
})
